import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=2d2c72ae&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"
import style0 from "./Logs.vue?vue&type=style&index=0&id=2d2c72ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c72ae",
  null
  
)

export default component.exports